export const collections = {
  "vacation": {
    "name": "vacation",
    "pascalName": "Vacation",
    "tableName": "_content_vacation",
    "source": [
      {
        "_resolved": true,
        "prefix": "/vacations",
        "include": "vacations/**/*.md",
        "cwd": "/vercel/path0/content"
      }
    ],
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json",
      "visitDate": "string",
      "slug": "string",
      "locale": "string",
      "image": "string",
      "type": "string",
      "countries": "json",
      "dayTrips": "json"
    },
    "schema": {
      "$ref": "#/definitions/vacation",
      "definitions": {
        "vacation": {
          "type": "object",
          "properties": {
            "id": {
              "type": "string"
            },
            "stem": {
              "type": "string"
            },
            "extension": {
              "type": "string",
              "enum": [
                "md",
                "yaml",
                "yml",
                "json",
                "csv",
                "xml"
              ]
            },
            "meta": {
              "type": "object",
              "additionalProperties": {}
            },
            "path": {
              "type": "string"
            },
            "title": {
              "type": "string"
            },
            "description": {
              "type": "string"
            },
            "seo": {
              "allOf": [
                {
                  "type": "object",
                  "properties": {
                    "title": {
                      "type": "string"
                    },
                    "description": {
                      "type": "string"
                    }
                  }
                },
                {
                  "type": "object",
                  "additionalProperties": {}
                }
              ],
              "default": {}
            },
            "body": {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string"
                },
                "children": {},
                "toc": {}
              },
              "required": [
                "type"
              ],
              "additionalProperties": false
            },
            "navigation": {
              "anyOf": [
                {
                  "type": "boolean"
                },
                {
                  "type": "object",
                  "properties": {
                    "title": {
                      "type": "string"
                    },
                    "description": {
                      "type": "string"
                    },
                    "icon": {
                      "type": "string"
                    }
                  },
                  "required": [
                    "title",
                    "description",
                    "icon"
                  ],
                  "additionalProperties": false
                }
              ],
              "default": true
            },
            "visitDate": {
              "type": "string"
            },
            "slug": {
              "type": "string"
            },
            "locale": {
              "type": "string"
            },
            "image": {
              "type": "string"
            },
            "type": {
              "type": "string",
              "enum": [
                "vacation"
              ]
            },
            "countries": {
              "type": "array",
              "items": {
                "type": "string"
              }
            },
            "dayTrips": {
              "type": "array",
              "items": {
                "type": "string"
              }
            }
          },
          "required": [
            "id",
            "stem",
            "extension",
            "meta",
            "path",
            "title",
            "body",
            "visitDate",
            "slug",
            "locale",
            "image",
            "type",
            "countries",
            "dayTrips"
          ],
          "additionalProperties": false
        }
      },
      "$schema": "http://json-schema.org/draft-07/schema#"
    },
    "tableDefinition": "CREATE TABLE IF NOT EXISTS _content_vacation (id TEXT PRIMARY KEY, \"title\" VARCHAR, \"body\" TEXT, \"countries\" TEXT, \"dayTrips\" TEXT, \"description\" VARCHAR, \"extension\" VARCHAR, \"image\" VARCHAR, \"locale\" VARCHAR, \"meta\" TEXT, \"navigation\" TEXT DEFAULT true, \"path\" VARCHAR, \"seo\" TEXT DEFAULT '{}', \"slug\" VARCHAR, \"stem\" VARCHAR, \"type\" VARCHAR, \"visitDate\" VARCHAR);"
  },
  "dayTrip": {
    "name": "dayTrip",
    "pascalName": "DayTrip",
    "tableName": "_content_dayTrip",
    "source": [
      {
        "_resolved": true,
        "prefix": "/dayTrips",
        "include": "dayTrips/**/day-trip*.md",
        "cwd": "/vercel/path0/content"
      }
    ],
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json",
      "visitDate": "string",
      "slug": "string",
      "locale": "string",
      "image": "string",
      "parent": "string",
      "type": "string",
      "countries": "json",
      "reviews": "json"
    },
    "schema": {
      "$ref": "#/definitions/dayTrip",
      "definitions": {
        "dayTrip": {
          "type": "object",
          "properties": {
            "id": {
              "type": "string"
            },
            "stem": {
              "type": "string"
            },
            "extension": {
              "type": "string",
              "enum": [
                "md",
                "yaml",
                "yml",
                "json",
                "csv",
                "xml"
              ]
            },
            "meta": {
              "type": "object",
              "additionalProperties": {}
            },
            "path": {
              "type": "string"
            },
            "title": {
              "type": "string"
            },
            "description": {
              "type": "string"
            },
            "seo": {
              "allOf": [
                {
                  "type": "object",
                  "properties": {
                    "title": {
                      "type": "string"
                    },
                    "description": {
                      "type": "string"
                    }
                  }
                },
                {
                  "type": "object",
                  "additionalProperties": {}
                }
              ],
              "default": {}
            },
            "body": {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string"
                },
                "children": {},
                "toc": {}
              },
              "required": [
                "type"
              ],
              "additionalProperties": false
            },
            "navigation": {
              "anyOf": [
                {
                  "type": "boolean"
                },
                {
                  "type": "object",
                  "properties": {
                    "title": {
                      "type": "string"
                    },
                    "description": {
                      "type": "string"
                    },
                    "icon": {
                      "type": "string"
                    }
                  },
                  "required": [
                    "title",
                    "description",
                    "icon"
                  ],
                  "additionalProperties": false
                }
              ],
              "default": true
            },
            "visitDate": {
              "type": "string"
            },
            "slug": {
              "type": "string"
            },
            "locale": {
              "type": "string"
            },
            "image": {
              "type": "string"
            },
            "parent": {
              "type": "string"
            },
            "type": {
              "type": "string",
              "enum": [
                "dayTrip"
              ]
            },
            "countries": {
              "type": "array",
              "items": {
                "type": "string"
              }
            },
            "reviews": {
              "type": "array",
              "items": {
                "type": "string"
              }
            }
          },
          "required": [
            "id",
            "stem",
            "extension",
            "meta",
            "path",
            "title",
            "body",
            "visitDate",
            "slug",
            "locale",
            "image",
            "parent",
            "type",
            "countries",
            "reviews"
          ],
          "additionalProperties": false
        }
      },
      "$schema": "http://json-schema.org/draft-07/schema#"
    },
    "tableDefinition": "CREATE TABLE IF NOT EXISTS _content_dayTrip (id TEXT PRIMARY KEY, \"title\" VARCHAR, \"body\" TEXT, \"countries\" TEXT, \"description\" VARCHAR, \"extension\" VARCHAR, \"image\" VARCHAR, \"locale\" VARCHAR, \"meta\" TEXT, \"navigation\" TEXT DEFAULT true, \"parent\" VARCHAR, \"path\" VARCHAR, \"reviews\" TEXT, \"seo\" TEXT DEFAULT '{}', \"slug\" VARCHAR, \"stem\" VARCHAR, \"type\" VARCHAR, \"visitDate\" VARCHAR);"
  },
  "review": {
    "name": "review",
    "pascalName": "Review",
    "tableName": "_content_review",
    "source": [
      {
        "_resolved": true,
        "prefix": "/reviews",
        "include": "reviews/**/review*.md",
        "cwd": "/vercel/path0/content"
      }
    ],
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json",
      "visitDate": "string",
      "slug": "string",
      "locale": "string",
      "image": "string",
      "type": "string",
      "countries": "json"
    },
    "schema": {
      "$ref": "#/definitions/review",
      "definitions": {
        "review": {
          "type": "object",
          "properties": {
            "id": {
              "type": "string"
            },
            "stem": {
              "type": "string"
            },
            "extension": {
              "type": "string",
              "enum": [
                "md",
                "yaml",
                "yml",
                "json",
                "csv",
                "xml"
              ]
            },
            "meta": {
              "type": "object",
              "additionalProperties": {}
            },
            "path": {
              "type": "string"
            },
            "title": {
              "type": "string"
            },
            "description": {
              "type": "string"
            },
            "seo": {
              "allOf": [
                {
                  "type": "object",
                  "properties": {
                    "title": {
                      "type": "string"
                    },
                    "description": {
                      "type": "string"
                    }
                  }
                },
                {
                  "type": "object",
                  "additionalProperties": {}
                }
              ],
              "default": {}
            },
            "body": {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string"
                },
                "children": {},
                "toc": {}
              },
              "required": [
                "type"
              ],
              "additionalProperties": false
            },
            "navigation": {
              "anyOf": [
                {
                  "type": "boolean"
                },
                {
                  "type": "object",
                  "properties": {
                    "title": {
                      "type": "string"
                    },
                    "description": {
                      "type": "string"
                    },
                    "icon": {
                      "type": "string"
                    }
                  },
                  "required": [
                    "title",
                    "description",
                    "icon"
                  ],
                  "additionalProperties": false
                }
              ],
              "default": true
            },
            "visitDate": {
              "type": "string"
            },
            "slug": {
              "type": "string"
            },
            "locale": {
              "type": "string"
            },
            "image": {
              "type": "string"
            },
            "type": {
              "type": "string",
              "enum": [
                "review"
              ]
            },
            "countries": {
              "type": "array",
              "items": {
                "type": "string"
              }
            }
          },
          "required": [
            "id",
            "stem",
            "extension",
            "meta",
            "path",
            "title",
            "body",
            "visitDate",
            "slug",
            "locale",
            "image",
            "type",
            "countries"
          ],
          "additionalProperties": false
        }
      },
      "$schema": "http://json-schema.org/draft-07/schema#"
    },
    "tableDefinition": "CREATE TABLE IF NOT EXISTS _content_review (id TEXT PRIMARY KEY, \"title\" VARCHAR, \"body\" TEXT, \"countries\" TEXT, \"description\" VARCHAR, \"extension\" VARCHAR, \"image\" VARCHAR, \"locale\" VARCHAR, \"meta\" TEXT, \"navigation\" TEXT DEFAULT true, \"path\" VARCHAR, \"seo\" TEXT DEFAULT '{}', \"slug\" VARCHAR, \"stem\" VARCHAR, \"type\" VARCHAR, \"visitDate\" VARCHAR);"
  },
  "info": {
    "name": "info",
    "pascalName": "Info",
    "tableName": "_content_info",
    "type": "data",
    "fields": {},
    "schema": {
      "$ref": "#/definitions/info",
      "definitions": {
        "info": {
          "type": "object",
          "properties": {
            "id": {
              "type": "string"
            },
            "version": {
              "type": "string"
            }
          },
          "required": [
            "id",
            "version"
          ],
          "additionalProperties": false
        }
      },
      "$schema": "http://json-schema.org/draft-07/schema#"
    },
    "tableDefinition": "CREATE TABLE IF NOT EXISTS _content_info (id TEXT PRIMARY KEY, \"version\" VARCHAR);"
  }
}
export const gitInfo = {
  "name": "ToSoTravels",
  "owner": "Alkmaar072",
  "url": "https://github.com/Alkmaar072/ToSoTravels"
}
export const appConfigSchema = {}